import Vue from 'vue';
import Router from 'vue-router';
import NER from './views/NER.vue';
import CoRef from './views/CoRef.vue';
import RelationExtraction from './views/RelationExtraction.vue';
import Config from './views/Config.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', name: 'NER', component: NER },
    { path: '/coref', name: 'CoRef', component: CoRef },
    { path: '/relation-extraction', name: 'RelationExtraction', component: RelationExtraction },
    { path: '/config', name: 'Config', component: Config },
  ],
});
